import { HengeLoadingInProcess } from "@/engine/henge/fallback/HengeLoadingInProcess";
import React, { useEffect, useState } from "react";
import { HngVector3 } from "@/utils/threeUtil";
import * as THREE from "three";

interface HengeLoadingSuspenseProps<T extends React.ComponentType<any>> {
  LazyComponent: React.LazyExoticComponent<
    React.ComponentType<
      React.ComponentProps<T> & {
        loadingDelayOver: boolean;
        onLoad?: (object?: THREE.Object3D) => void;
      }
    >
  >;
  props: React.ComponentProps<T>;
  id: number;
  position: HngVector3;
  rotation: HngVector3;
  size: HngVector3;
}

export function HengeLoadingSuspense<T extends React.ComponentType<any>>({
  LazyComponent,
  props,
  // id,
  position,
  // rotation,
  size,
}: HengeLoadingSuspenseProps<T>) {
  const [loadingDelayOver, setLoadingDelayOver] = useState(false);
  const [isAfterRender, setIsAfterRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoadingDelayOver(true), 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <React.Suspense
      fallback={
        <HengeLoadingInProcess
          position={position}
          size={size ?? { x: 0, y: 0, z: 0 }}
        />
      }
    >
      {(!isAfterRender || !loadingDelayOver) && (
        <HengeLoadingInProcess
          position={position}
          size={size ?? { x: 0, y: 0, z: 0 }}
        />
      )}
      <LazyComponent
        {...props}
        loadingDelayOver={loadingDelayOver}
        onLoad={(object?: THREE.Object3D) => {
          if (props.onLoad) {
            props.onLoad(object);
          }
          setIsAfterRender(true);
        }}
      />
    </React.Suspense>
  );
}
